(function () {
  function ensureDelegatedTrigger() {
    if (window.__oBookDelegatedTriggerBound) return;
    window.__oBookDelegatedTriggerBound = true;

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-o-book]') : null;
      if (!trigger) return;

      var key = trigger.getAttribute('data-o-book');
      var activeRoot = document.querySelector('[data-o-book-root][data-o-book-bound="1"]');
      var controller = activeRoot && activeRoot.__oBookController;
      if (!key || !controller || !controller.urls[key]) return;

      e.preventDefault();
      e.stopPropagation();
      controller.open(key, trigger);
    });
  }

  function parseLegacy(selectorList) {
    if (!selectorList || typeof selectorList !== 'string') return [];
    return selectorList
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function initRoot(root) {
    if (!root || root.dataset.oBookBound === '1') return;
    root.dataset.oBookBound = '1';

    var cfgEl = root.querySelector('[data-o-book-config]');
    var frameWrap = root.querySelector('[data-o-book-frame]');
    if (!cfgEl || !frameWrap) return;

    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { cfg = {}; }
    var legacy = cfg.legacy || {};
    var urls = {
      'eye-test': cfg['eye-test'] || '',
      sv: cfg.sv || '',
      mg: cfg.mg || '',
      dtg: cfg.dtg || ''
    };

    var lastFocus = null;
    var currentKey = null;

    function open(key, trigger) {
      var src = urls[key];
      if (!src) return;
      currentKey = key;
      lastFocus = trigger || document.activeElement;
      frameWrap.innerHTML =
        '<iframe src="' + src.replace(/"/g, '&quot;') + '" title="Schedule Appointment" width="100%" height="800" frameborder="0" allow="payment" loading="eager"></iframe>';
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('o-book-lock');
      var closeBtn = root.querySelector('[data-o-book-close].o-book__close, .o-book__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('o-book-lock');
      frameWrap.innerHTML = '';
      currentKey = null;
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
      lastFocus = null;
    }

    root.__oBookController = { open: open, close: close, urls: urls };
    ensureDelegatedTrigger();

    root.querySelectorAll('[data-o-book-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        e.preventDefault();
        close();
      }
    });

    function bindTriggers() {
      // Instant class fallbacks during phase-out
      Object.keys(legacy).forEach(function (key) {
        parseLegacy(legacy[key]).forEach(function (sel) {
          try {
            document.querySelectorAll(sel).forEach(function (el) {
              if (el.dataset.oBookLegacyBound === key) return;
              el.dataset.oBookLegacyBound = key;
              el.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                open(key, el);
              });
            });
          } catch (err) {}
        });
      });
    }

    bindTriggers();
    // Instant / theme editor may inject later
    document.addEventListener('shopify:section:load', bindTriggers);
    // light mutation pass for Instant after paint
    window.setTimeout(bindTriggers, 800);
    window.setTimeout(bindTriggers, 2500);
  }

  function boot() {
    document.querySelectorAll('[data-o-book-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
